import PageLoader from '@ui_components/PageLoader';
import { getCookie } from '@utility/cookies';
import { getEnvironmentVariablesValue } from '@utility/environmentVariables';
import getTokenDetails from '@utility/getTokenDetails';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

const MainContainer = dynamic(() => import('@containers/MainContainer'), { loading: () => <PageLoader /> });

type LoginComponentProps = {
    tokenDetails: TokenDetailsProps
}

const LoginPage = ({ tokenDetails }: LoginComponentProps) => {
    return (
        <MainContainer defaultPage="login" tokenDetails={tokenDetails} organizationName={getEnvironmentVariablesValue("DEFAULT_ORGANIZATION")} />
    );
}

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
    const cookies = (req.headers.cookie || "")
    const { ssoId = '' } = query
    let accessToken = ''

    if (ssoId) {
        accessToken = String(query?.token || getCookie(`sso_access_token_${ssoId}`, cookies) || "")
    } else {
        accessToken = String(query?.token || getCookie("access_token", cookies) || "")
    }
    const tokenDetails = await getTokenDetails(accessToken)
    return {
        props: {
            tokenDetails: tokenDetails
        },
    };
};

export default LoginPage
